import API from './api';

export default class User extends API {
  constructor(config = {}) {
    config.path = 'users';

    super(config);
  }

  identifier(resource = '', params = {}) {
    return this.get('identifier', params);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/user.js
 **/